import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "./LanguageContext";
import { HomeProject, NewsSlider } from "./MultiCarousel";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import ReactPlayer from "react-player";
import { Link } from "react-scroll";
import { Helmet } from "react-helmet";
import axios from "axios";
import md5 from "md5";

const englishData = {
  section1: {
    title: "Press Media",
  },
  section2: {
    title: "News",
    // news: [
    //    {
    //       title: "KDCC Bank Chairman Tejas Patel's unopposed election",
    //       id: '2024',
    //       text: "<p>Tejasbhai Patel, the newly appointed chairman, is determined to take banking services to the doorsteps of the people in rural areas.<br/>Tejas Patel, also known as Jigabhai, has been unopposed for the fifth time as a director of the Kheda, Anand and Mahisagar districts of the bank, which has more than 9 lakh farmers and account holders.  <br/>KDCC Bank, known as the country's first cooperative bank, Kheda District Central Cooperative Bank Ltd. has been unanimously elected as its chairman. On this occasion, KDCC Bank directors, Gujarat Legislative Assembly Deputy Speaker and GSSC Bank representative Jethabhai Bharwad, Gujarat BJP सहकारिता Cell convener Bipin Patel (Gota), Amul Dairy chairman Vipul Patel, Nadiad MLA Pankaj Desai, Kheda district BJP president Ajay Brahmbhatt and other dignitaries were present. <br/>It is noteworthy that Tejas Patel has been unanimously elected as the chairman of the Kheda District Central Cooperative Bank Ltd., Nadiad, as per the orders of the Gujarat Pradesh President, BJP (Gota) Vara Bhajwapa and in accordance with the whip of the Gujarat BJP सहकारिता Cell. The directors who were elected unopposed accepted it happily and congratulated Tejasbhai Patel.<br/>The text mentions that Tejas Patel is the new chairman of the Kheda District Central Cooperative Bank Ltd. (KDCC Bank) <br/>Patel was elected unopposed for the fifth time as a director of the bank.<br/>The bank serves more than 9 lakh farmers and account holders in the Kheda, Anand, and Mahisagar districts of Gujarat. <br/>Patel is determined to take banking services to the doorsteps of the people in rural areas. </p>",
    //       date: " ",
    //       // img: `${require('../images/news7.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: "KDCC Bank gets first chairman from Anand district",
    //       id: '2024',
    //       text: "<p>Tejas Patel becomes chairman after 'pilgrimage' with Shah in Salangpur </p>",
    //       date: " ",
    //       // img: `${require('../images/news8.jpg')}`,
    //       readmore: 'read More'
    //    },

    //    {
    //       title: "Gujarat CM Bhupendra Patel to visit Anand today",
    //       id: '2024',
    //       text: "<p>Will hold meetings with government officials, सहकारी (cooperatives), and political leaders  <br/>Will also attend a sports competition and encourage the players <br/>Gujarat Chief Minister Bhupendra Patel is visiting Anand today. <br/>He will hold meetings with government officials, सहकारी (cooperatives), and political leaders. <br/>He will also attend a sports competition and encourage the players.</p>,",
    //       date: " ",
    //       // img: `${require('../images/news9.jpg')}`,
    //       readmore: 'read More'
    //    },

    //    {
    //       title: "Tejas Patel elected as the chairman of The Kaira District Central Co-operative Bank Ltd. (KDCC Bank)",
    //       id: '2023',
    //       text: " <p>The unopposed election of Tejas Patel as the chairman of KDCC Bank took place at the bank's conference hall in the presence of the Additional Collector.<br/>Patidar community leader Tejas Patel, who is also the chairman of Petlad APMC, has been elected unopposed as the chairman of KDCC Bank.,<br/>During the event, former Chief Whip and Nadiad MLA Pankaj Desai, Gujarat State Cooperative Cell convener Bipin Patel, BJP's Kheda district president Ajay Brahmbhatt, Amul Dairy chairman Vipul Patel, Panchmahal Dairy chairman Jethabhai Bharwad, Thasra MLA Yogendrasinh Parmar, vice-chairman Rajendrasinh Parmar, director Dhirajbhai Chavda, director Bhadraeshbhai Shah, and other directors of KDCC Bank were present.,<br/>The text mentions that Tejas Patel has been elected as the new chairman of The Kaira District Central Co-operative Bank Ltd. (KDCC Bank). ,<br/>Patel is a Patidar community leader and is also the chairman of Petlad APMC.,<br/>He was elected unopposed during a meeting at the bank's conference hall.</p>  ",
    //       date: " ",
    //       // img: `${require('../images/news10.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: 'KDCC Bank holds discussions with American delegation Decision to establish Indo-American Cooperative Bank in Pennsylvania',
    //       id: '2023',
    //       text: "<p>Discussions were held on how the bank can do a lot for the welfare and prosperity of the people living in Anand, the original Indians who went from India to America, and to provide education loans to students going for higher education in America.<br/>A delegation from Pennsylvania visiting Gujarat to explore the possibilities of setting up a cooperative bank, inspired by the models of GSC and KDCC banks in Pennsylvania.<br/>The Pennsylvania state has taken steps for a collaborative initiative with Gujarat in various fields like cooperative sector, medical education, technical education, banking, solar energy.<br/>Aaron Kaufer, a member of the Pennsylvania delegation, said that by setting up a cooperative bank or dairy in Pennsylvania, a lot can be done for the welfare of the people, especially the farmers. Through cooperatives, something special can be done for the needy people. It is to work together to pave the way for prosperity. Alpesh Patel, president of the Indo American Community of Scranton, said that widespread people are being educated about the growing profile of Indian Americans in the USA. He also said that he visited Gujarat to explore the possibilities of collaborative activities in various fields like medical education, cooperative dairy, cooperative bank, solar energy.<br/> <span style={{ fontWeight: '600' }}>Representatives Aaron Kaufer, House Legislative Session, Consumer Protection, Technology and Utilities, Gaming Oversight and Local Government Committees member Alec Rinkvech and Indo American Community of Scranton and PA Small Business Retailer Association and El Quick Stop Management President Alpesh Patel visited Gujarat.</span><br/>The delegation obtained information about the banking facilities available for farmers by GSC Bank and KDCC Bank. They also discussed the possibility of setting up an Indo-American Cooperative Bank in Pennsylvania.<br/> <span  style={{ fontWeight: '600' }}>Gujarat BJP Cooperatives Cell State Member and KDCC Bank Chairman Tejas Patel said that with the aim of bringing economic prosperity in the relations of India and the countries of the world, Prime Minister Narendra Modi and Home Minister and first Cooperatives Minister Amit Shah are holding consultations with various countries. When a representative delegation from the US state of Pennsylvania is visiting India to explore Indian culture and its vast economy, it is a big deal.</span></p>",
    //       date: 'Thu, 23 November 2023',
    //       // img: `${require('../images/news1.jpeg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: "Petlad Agricultural Produce Market Committee  ",
    //       id: '2022',
    //       text: " <p>Dialogue with cooperative leaders held under the chairmanship of Assam's former Chief Minister and Union Cabinet Minister Sarbananda Sonowal<br/> <span style={{ fontWeight: '600' }}>Anand : </span>    A dialogue with cooperative leaders was held at the Petlad Agricultural Produce Market Committee under the chairmanship of Assam's former Chief Minister and Union Cabinet Minister Sarbananda Sonowal. On the occasion, the Union Minister appreciated the work being done in the cooperative sector in the direction of the Orange Revolution.<br/> <span style={{ fontWeight: '600' }}>Leaders present : </span>Anand Lok Sabha MP Shardanandbhai Brahmbhatt, Anand District BJP President Vipulbhai Patel, MP Mitesh Patel, BJP Cooperatives Cell State Member Tejasbhai Patel, State Spokesperson Bharatbhai Dangar, District BJP General Secretary Mayurbhai Sutaria, Khambhat MLA Mayurbhai Raval, former MP Lalsinh Vadodariya, Petlad APMC Chairman Sandip Patel, District BJP former president Maheshbhai Patel, former MLA Kunwar Sinh Chauhan, Nadiad APMC Chairman Kanu Patel, Sojitra Nagar Palika President Rajnikanthbhai, Petlad BJP City President Dharmendrabhai Parmar, Petlad, Sojitra, Tarapur and Khambhat APMC directors and cooperative sector leaders and farmers were present.<br/> <span style={{ fontWeight: '600' }}>Welcome by BJP Cooperatives Cell : </span> Union Cabinet Minister Sarbananda Sonowal was welcomed by Tejas Patel, State Member of BJP Cooperatives Cell. Union Minister Sarbananda Sonowal said that Prime Minister Narendra Modi's vision for solar energy is 'Surya Shakti-From Surya everything is created', he emphasized the power of clean solar energy. He emphasized the vision of 'One Sun, One World, One Grid' and appreciated the work done by the cooperative institutions in the field of solar in the Anand district through solarization. He also called upon the whole country to move forward step by step with the 'Orange Revolution' towards a new direction.</p>",
    //       date: 'Friday, September 16, 2022',
    //       // img: `${require('../images/news2.jpg')}`,
    //       readmore: 'read More'

    //    },
    //    {
    //       title: "Gujarat Niyantrit Bazar Sangh Tejas Patel elected as Honorary Joint Secretary from Central Gujarat",
    //       id: '2022',
    //       text: "<p>The Bharatiya Janata Party (BJP) panel was elected unopposed in the elections for the Ahmedabad market committee.<br/>The committee will work on planning policies for the development of market committees and the all-round development of farmers. To realize the farmer-centric resolutions of Prime Minister Narendra Modi, well-organized planning will be done to ensure that farmers get proper returns and affordable prices for the agricultural produce they produce under the e-NAM scheme implemented by the Central Government. Planning will be done to ensure that the scheme reaches the farmers <br/> <span style={{ fontWeight: '600' }}>Patlad taluka youth: Cooperative leader and former chairman of Petlad APMC, Tejas Patel alias Jigabhai has been elected as honorary joint secretary from Central Gujarat in the Gujarat Niyantrit Bazar Sangh, Ahmedabad. The BJP panel was declared unopposed in the GNBS elections.</span></p>",
    //       date: ' ',
    //       // img: `${require('../images/news3.jpg')}`,
    //       readmore: 'read More'

    //    },
    //    {
    //       title: 'Kheda District Central Co-operative Bank Board of Directors Meeting: Historic decisions taken ',
    //       id: '2021',
    //       text: "<p style={{ fontWeight: '600' }}>The first meeting of the board of directors of the Kheda District Central Co-operative Bank, Gujarat's leading district bank, was held in the conference hall of Sahkar Bhavan, which functions at Ekta Nagar, Statue of Unity, after it started functioning there. The meeting was held under the chairmanship of the bank's chairman Tejasbhai Patel-Jigabhai. Gopal Bamaniya, Additional Collector of Ekta Nagar, Rahulbhai, a leader, and members of the board of directors were present in the meeting.<br/>The meeting expressed hope for the bank's continuous progress and decided to expedite the digital medium for its customers. It was decided to launch the distribution of free QR codes at historical places in the state by the bank and to start customer service centers. The bank has also issued a customer care service phone number.<br/>The meeting of the board of directors of the bank, which was held at a historical place, also took some historical decisions. In one such decision, it was decided to change the bank's name from its old name, The Kaira District Central Co-operative Bank Limited which it had during the British Raj, to The Kheda District Central Co-operative Bank Limited with immediate effect. </p>",
    //       date: ' ',
    //       // img: `${require('../images/news4.jpeg')}`,
    //       readmore: 'read More'

    //    },
    //    {
    //       title: 'Narmada Sugar has started production of the first pharmaceutical-grade sugar in the state Launched by Panchmahal Dairy Chairman MLA Jetha Bharwad',
    //       id: '2021',
    //       text: "<p>Narmada Suger Dharikhed Sugar Factory of the Narmada district, which is the lifeline of the district, is progressing day by day and is launching one project after another. It is establishing its place among the best sugar factories in the state and the southern zone of the country. Recently, a special type of sugar used in medicines, called pharmaceutical-grade sugar, has been produced by the Narmada Sugar Factory. This sugar, ready to be packed, was launched by Jethabhai Bharwad, MLA from the city area, cooperative leader, and chairman of the Panchmahal district's Panchamrut Dairy. He also inspected the sugar factory, distillery plant, fertilizer plant, and the work of the officials and employees there. He was very happy to see the transparent administration in the factory.<br>Along with Jethabhai Bharwad, Tejash Patel, the chairman of the Distrik Bank and former Deputy Collector, was also present. He was very impressed by the management of the sugar factory and the employees. </p>",
    //       date: ' ',
    //       // img: `${require('../images/news5.jpeg')}`,
    //       readmore: 'read More'

    //    },
    //    {
    //       title: 'Sojitra APMC in Anand district: All 10 seats of the farmer category are won by BJP candidates unopposed',
    //       id: '2020',
    //       text: "<p>The Gujarat BJP सहकारी (Sahakar) Cell Incharge Bipinbhai Patel announced that all 10 seats of the farmer category in the Sojitra Agricultural Produce Market Committee (APMC) were won by BJP candidates unopposed. As a result, the saffron flag of BJP has been hoisted in Sojitra APMC<br/>The winning candidates in the farmer category include Kishorbhai Chhotabhai Patel (Bhadkad), Jayeshbhai Narsinhbhai Patel (Dhaboi), Melabhai Kabhai bhai Gohil (Deva Talpad), Rajnikant Jashbhai Patel (Sojitra), Devtabhai Ravjibhai Patel (Kasor), and Maheshbhai Manibhai Patel (Isnana) among others.<br/>The BJP winning candidates expressed their gratitude to all the voters of the taluka.</p>",
    //       date: ' ',
    //       // img: `${require('../images/news6.jpg')}`,
    //       readmore: 'read More'
    //    },

    // ]
  },
  section3: {
    title: "Videos",
    // news: [
    //    {
    //       title: 'INTERVIEW',
    //       id: 'INTERVIEW',
    //       url: 'https://youtu.be/0GNAfi72zho?si=0V4ykFB_BzJrxFzR',
    //    },
    //    {
    //       title: 'INTERVIEW',
    //       id: 'INTERVIEW',
    //       url: 'https://youtu.be/N7bHOfRhiSQ',
    //    },
    //    {
    //       title: 'INTERVIEW',
    //       id: 'INTERVIEW',
    //       url: 'https://youtu.be/0czUsxNum_I',
    //    },
    //    {
    //       title: 'PARTY EVENTS',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/M4YqP5fPVWg ',
    //    },
    //    {
    //       title: 'PARTY EVENTS',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/eZTUiPVG-rk',
    //    },
    //    {
    //       title: 'PARTY EVENTS',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/eLig8YDS89Q ',
    //    },
    //    {
    //       title: 'PARTY EVENTS',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/M4YqP5fPVWg',
    //    },
    //    {
    //       title: 'PARTY EVENTS',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/M4YqP5fPVWg ',
    //    },
    //    {
    //       title: 'PARTY EVENTS',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/e7gm4Mh_ST4',
    //    },
    //    {
    //       title: 'PARTY EVENTS',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/1Z575rF7qSo ',
    //    },
    //    {
    //       title: 'PARTY EVENTS',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/7JNQ4Whn2iU',
    //    },
    //    {
    //       title: 'ELECTION RALLY',
    //       id: 'ELECTION RALLY',
    //       url: 'https://youtu.be/BShMG9UuHhg ',
    //    },
    //    {
    //       title: 'ELECTION RALLY',
    //       id: 'ELECTION RALLY',
    //       url: 'https://youtu.be/i3XTfZnDyaU',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/iAmKjQNellY ',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/S1YFq1W4jIE',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/xfsvE4ZRs6o ',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/YjzJgK8VlF0',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/z8_4r8lLKoc ',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/T9ODfvFeTYc',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/M4YqP5fPVWg ',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/eZTUiPVG-rk',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/eLig8YDS89Q ',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/M4YqP5fPVWg',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/ua3wHBnlLFE ',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/e7gm4Mh_ST4',
    //    },
    //    {
    //       title: 'PRESS CONFERENCE',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/1Z575rF7qSo ',
    //    },
    //    {
    //       title: 'LIGHTER SIDE',
    //       id: 'LIGHTER SIDE',
    //       url: 'https://youtu.be/6CdM22yUXnI',
    //    },
    //    {
    //       title: 'LIGHTER SIDE',
    //       id: 'LIGHTER SIDE',
    //       url: 'https://youtu.be/6-HebmvUMd4',
    //    },
    //    {
    //       title: 'OTHER',
    //       id: 'OTHER',
    //       url: 'https://youtu.be/NSeIl5mCCPg',
    //    },
    //    {
    //       title: 'OTHER',
    //       id: 'OTHER',
    //       url: 'https://youtu.be/gAjxX7bifN4',
    //    },
    //    {
    //       title: 'OTHER',
    //       id: 'OTHER',
    //       url: 'https://youtu.be/ByT2CJNrCzE',
    //    },

    // ]
  },
  section4: {
    title: "Editorials",
    // farmers1: {
    //    title: "Four nomination papers filed for Kadi Sarsi Bank elections",
    //    text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //    date: ' ',
    //    // img: `${require('../images/aditorials1.jpg')}`,
    //    readmore: 'Read More'
    // },
    // farmers2: [
    //    {
    //       title: "Four nomination papers filed for Kadi Sarsi Bank elections",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/aditorials1.jpg')}`,
    //       readmore: 'Read More'
    //    },
    //    {
    //       title: "Tejas Patel elected unopposed as chairman of Petlad APMC",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/aditorials2.jpg')}`,
    //       readmore: 'Read More'
    //    },
    //    {
    //       title: "Training for farmers on cashless transactions in Petlad",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",

    //       date: ' ',
    //       // img: `${require('../images/aditorials3.jpg')}`,
    //       readmore: 'Read More'
    //    },
    //    {
    //       title: "Online auction system will be set up for selling paddy",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",

    //       date: ' ',
    //       // img: `${require('../images/aditorials4.jpg')}`,
    //       readmore: 'Read More'
    //    },
    // ]
  },
  section5: {
    title: "Our Activity",
    // activity: [
    //    {
    //       title: "Amul's 32 direct recruitments challenged",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/pressOurActivity1.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: "Farmers of Petlad-Sojitra will benefit",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/pressOurActivity2.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: " Groundbreaking ceremony of new building of Gujcomasol",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/pressOurActivity3.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: "Piplav Dairy Union member's membership canceled for supplying adulterated milk",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/pressOurActivity4.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: 'Milk producers are in a bad condition due to not getting money for the last 8 days.',
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/pressOurActivity5.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: "Historical decision to fight against black money welcomed",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/pressOurActivity6.jpg')}`,
    //       readmore: 'read More'
    //    },
    // ]
  },
};

const gujratData = {
  section1: {
    title: "પ્રેસ મીડિયા",
  },
  section2: {
    title: "News",
    // news: [
    //    {
    //       title: "KDCC Bank Chairman Tejas Patel's unopposed election",
    //       id: '2024',
    //       text: "<p>Tejasbhai Patel, the newly appointed chairman, is determined to take banking services to the doorsteps of the people in rural areas.<br/>Tejas Patel, also known as Jigabhai, has been unopposed for the fifth time as a director of the Kheda, Anand and Mahisagar districts of the bank, which has more than 9 lakh farmers and account holders.  <br/>KDCC Bank, known as the country's first cooperative bank, Kheda District Central Cooperative Bank Ltd. has been unanimously elected as its chairman. On this occasion, KDCC Bank directors, Gujarat Legislative Assembly Deputy Speaker and GSSC Bank representative Jethabhai Bharwad, Gujarat BJP सहकारिता Cell convener Bipin Patel (Gota), Amul Dairy chairman Vipul Patel, Nadiad MLA Pankaj Desai, Kheda district BJP president Ajay Brahmbhatt and other dignitaries were present. <br/>It is noteworthy that Tejas Patel has been unanimously elected as the chairman of the Kheda District Central Cooperative Bank Ltd., Nadiad, as per the orders of the Gujarat Pradesh President, BJP (Gota) Vara Bhajwapa and in accordance with the whip of the Gujarat BJP सहकारिता Cell. The directors who were elected unopposed accepted it happily and congratulated Tejasbhai Patel.<br/>The text mentions that Tejas Patel is the new chairman of the Kheda District Central Cooperative Bank Ltd. (KDCC Bank) <br/>Patel was elected unopposed for the fifth time as a director of the bank.<br/>The bank serves more than 9 lakh farmers and account holders in the Kheda, Anand, and Mahisagar districts of Gujarat. <br/>Patel is determined to take banking services to the doorsteps of the people in rural areas. </p>",
    //       date: " ",
    //       img: `${require('../images/news7.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: "KDCC Bank gets first chairman from Anand district",
    //       id: '2024',
    //       text: "<p>Tejas Patel becomes chairman after 'pilgrimage' with Shah in Salangpur </p>",
    //       date: " ",
    //       // img: `${require('../images/news8.jpg')}`,
    //       readmore: 'read More'
    //    },

    //    {
    //       title: "Gujarat CM Bhupendra Patel to visit Anand today",
    //       id: '2024',
    //       text: "<p>Will hold meetings with government officials, सहकारी (cooperatives), and political leaders  <br/>Will also attend a sports competition and encourage the players <br/>Gujarat Chief Minister Bhupendra Patel is visiting Anand today. <br/>He will hold meetings with government officials, सहकारी (cooperatives), and political leaders. <br/>He will also attend a sports competition and encourage the players.</p>,",
    //       date: " ",
    //       // img: `${require('../images/news9.jpg')}`,
    //       readmore: 'read More'
    //    },

    //    {
    //       title: "Tejas Patel elected as the chairman of The Kaira District Central Co-operative Bank Ltd. (KDCC Bank)",
    //       id: '2023',
    //       text: " <p>The unopposed election of Tejas Patel as the chairman of KDCC Bank took place at the bank's conference hall in the presence of the Additional Collector.<br/>Patidar community leader Tejas Patel, who is also the chairman of Petlad APMC, has been elected unopposed as the chairman of KDCC Bank.,<br/>During the event, former Chief Whip and Nadiad MLA Pankaj Desai, Gujarat State Cooperative Cell convener Bipin Patel, BJP's Kheda district president Ajay Brahmbhatt, Amul Dairy chairman Vipul Patel, Panchmahal Dairy chairman Jethabhai Bharwad, Thasra MLA Yogendrasinh Parmar, vice-chairman Rajendrasinh Parmar, director Dhirajbhai Chavda, director Bhadraeshbhai Shah, and other directors of KDCC Bank were present.,<br/>The text mentions that Tejas Patel has been elected as the new chairman of The Kaira District Central Co-operative Bank Ltd. (KDCC Bank). ,<br/>Patel is a Patidar community leader and is also the chairman of Petlad APMC.,<br/>He was elected unopposed during a meeting at the bank's conference hall.</p>  ",
    //       date: " ",
    //       // img: `${require('../images/news10.jpg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: 'KDCC Bank holds discussions with American delegation Decision to establish Indo-American Cooperative Bank in Pennsylvania',
    //       id: '2023',
    //       text: "<p>Discussions were held on how the bank can do a lot for the welfare and prosperity of the people living in Anand, the original Indians who went from India to America, and to provide education loans to students going for higher education in America.<br/>A delegation from Pennsylvania visiting Gujarat to explore the possibilities of setting up a cooperative bank, inspired by the models of GSC and KDCC banks in Pennsylvania.<br/>The Pennsylvania state has taken steps for a collaborative initiative with Gujarat in various fields like cooperative sector, medical education, technical education, banking, solar energy.<br/>Aaron Kaufer, a member of the Pennsylvania delegation, said that by setting up a cooperative bank or dairy in Pennsylvania, a lot can be done for the welfare of the people, especially the farmers. Through cooperatives, something special can be done for the needy people. It is to work together to pave the way for prosperity. Alpesh Patel, president of the Indo American Community of Scranton, said that widespread people are being educated about the growing profile of Indian Americans in the USA. He also said that he visited Gujarat to explore the possibilities of collaborative activities in various fields like medical education, cooperative dairy, cooperative bank, solar energy.<br/> <span style={{ fontWeight: '600' }}>Representatives Aaron Kaufer, House Legislative Session, Consumer Protection, Technology and Utilities, Gaming Oversight and Local Government Committees member Alec Rinkvech and Indo American Community of Scranton and PA Small Business Retailer Association and El Quick Stop Management President Alpesh Patel visited Gujarat.</span><br/>The delegation obtained information about the banking facilities available for farmers by GSC Bank and KDCC Bank. They also discussed the possibility of setting up an Indo-American Cooperative Bank in Pennsylvania.<br/> <span  style={{ fontWeight: '600' }}>Gujarat BJP Cooperatives Cell State Member and KDCC Bank Chairman Tejas Patel said that with the aim of bringing economic prosperity in the relations of India and the countries of the world, Prime Minister Narendra Modi and Home Minister and first Cooperatives Minister Amit Shah are holding consultations with various countries. When a representative delegation from the US state of Pennsylvania is visiting India to explore Indian culture and its vast economy, it is a big deal.</span></p>",
    //       date: 'Thu, 23 November 2023',
    //       // img: `${require('../images/news1.jpeg')}`,
    //       readmore: 'read More'
    //    },
    //    {
    //       title: "Petlad Agricultural Produce Market Committee  ",
    //       id: '2022',
    //       text: " <p>Dialogue with cooperative leaders held under the chairmanship of Assam's former Chief Minister and Union Cabinet Minister Sarbananda Sonowal<br/> <span style={{ fontWeight: '600' }}>Anand : </span>    A dialogue with cooperative leaders was held at the Petlad Agricultural Produce Market Committee under the chairmanship of Assam's former Chief Minister and Union Cabinet Minister Sarbananda Sonowal. On the occasion, the Union Minister appreciated the work being done in the cooperative sector in the direction of the Orange Revolution.<br/> <span style={{ fontWeight: '600' }}>Leaders present : </span>Anand Lok Sabha MP Shardanandbhai Brahmbhatt, Anand District BJP President Vipulbhai Patel, MP Mitesh Patel, BJP Cooperatives Cell State Member Tejasbhai Patel, State Spokesperson Bharatbhai Dangar, District BJP General Secretary Mayurbhai Sutaria, Khambhat MLA Mayurbhai Raval, former MP Lalsinh Vadodariya, Petlad APMC Chairman Sandip Patel, District BJP former president Maheshbhai Patel, former MLA Kunwar Sinh Chauhan, Nadiad APMC Chairman Kanu Patel, Sojitra Nagar Palika President Rajnikanthbhai, Petlad BJP City President Dharmendrabhai Parmar, Petlad, Sojitra, Tarapur and Khambhat APMC directors and cooperative sector leaders and farmers were present.<br/> <span style={{ fontWeight: '600' }}>Welcome by BJP Cooperatives Cell : </span> Union Cabinet Minister Sarbananda Sonowal was welcomed by Tejas Patel, State Member of BJP Cooperatives Cell. Union Minister Sarbananda Sonowal said that Prime Minister Narendra Modi's vision for solar energy is 'Surya Shakti-From Surya everything is created', he emphasized the power of clean solar energy. He emphasized the vision of 'One Sun, One World, One Grid' and appreciated the work done by the cooperative institutions in the field of solar in the Anand district through solarization. He also called upon the whole country to move forward step by step with the 'Orange Revolution' towards a new direction.</p>",
    //       date: 'Friday, September 16, 2022',
    //       // img: `${require('../images/news2.jpg')}`,
    //       readmore: 'read More'

    //    },
    //    {
    //       title: "Gujarat Niyantrit Bazar Sangh Tejas Patel elected as Honorary Joint Secretary from Central Gujarat",
    //       id: '2022',
    //       text: "<p>The Bharatiya Janata Party (BJP) panel was elected unopposed in the elections for the Ahmedabad market committee.<br/>The committee will work on planning policies for the development of market committees and the all-round development of farmers. To realize the farmer-centric resolutions of Prime Minister Narendra Modi, well-organized planning will be done to ensure that farmers get proper returns and affordable prices for the agricultural produce they produce under the e-NAM scheme implemented by the Central Government. Planning will be done to ensure that the scheme reaches the farmers <br/> <span style={{ fontWeight: '600' }}>Patlad taluka youth: Cooperative leader and former chairman of Petlad APMC, Tejas Patel alias Jigabhai has been elected as honorary joint secretary from Central Gujarat in the Gujarat Niyantrit Bazar Sangh, Ahmedabad. The BJP panel was declared unopposed in the GNBS elections.</span></p>",
    //       date: ' ',
    //       img: `${require('../images/news3.jpg')}`,
    //       readmore: 'read More'

    //    },
    //    {
    //       title: 'Kheda District Central Co-operative Bank Board of Directors Meeting: Historic decisions taken ',
    //       id: '2021',
    //       text: "<p style={{ fontWeight: '600' }}>The first meeting of the board of directors of the Kheda District Central Co-operative Bank, Gujarat's leading district bank, was held in the conference hall of Sahkar Bhavan, which functions at Ekta Nagar, Statue of Unity, after it started functioning there. The meeting was held under the chairmanship of the bank's chairman Tejasbhai Patel-Jigabhai. Gopal Bamaniya, Additional Collector of Ekta Nagar, Rahulbhai, a leader, and members of the board of directors were present in the meeting.<br/>The meeting expressed hope for the bank's continuous progress and decided to expedite the digital medium for its customers. It was decided to launch the distribution of free QR codes at historical places in the state by the bank and to start customer service centers. The bank has also issued a customer care service phone number.<br/>The meeting of the board of directors of the bank, which was held at a historical place, also took some historical decisions. In one such decision, it was decided to change the bank's name from its old name, The Kaira District Central Co-operative Bank Limited which it had during the British Raj, to The Kheda District Central Co-operative Bank Limited with immediate effect. </p>",
    //       date: ' ',
    //       // img: `${require('../images/news4.jpeg')}`,
    //       readmore: 'read More'

    //    },
    //    {
    //       title: 'Narmada Sugar has started production of the first pharmaceutical-grade sugar in the state Launched by Panchmahal Dairy Chairman MLA Jetha Bharwad',
    //       id: '2021',
    //       text: "<p>Narmada Suger Dharikhed Sugar Factory of the Narmada district, which is the lifeline of the district, is progressing day by day and is launching one project after another. It is establishing its place among the best sugar factories in the state and the southern zone of the country. Recently, a special type of sugar used in medicines, called pharmaceutical-grade sugar, has been produced by the Narmada Sugar Factory. This sugar, ready to be packed, was launched by Jethabhai Bharwad, MLA from the city area, cooperative leader, and chairman of the Panchmahal district's Panchamrut Dairy. He also inspected the sugar factory, distillery plant, fertilizer plant, and the work of the officials and employees there. He was very happy to see the transparent administration in the factory.<br>Along with Jethabhai Bharwad, Tejash Patel, the chairman of the Distrik Bank and former Deputy Collector, was also present. He was very impressed by the management of the sugar factory and the employees. </p>",
    //       date: ' ',
    //       // img: `${require('../images/news5.jpeg')}`,
    //       readmore: 'read More'

    //    },
    //    {
    //       title: 'Sojitra APMC in Anand district: All 10 seats of the farmer category are won by BJP candidates unopposed',
    //       id: '2020',
    //       text: "<p>The Gujarat BJP सहकारी (Sahakar) Cell Incharge Bipinbhai Patel announced that all 10 seats of the farmer category in the Sojitra Agricultural Produce Market Committee (APMC) were won by BJP candidates unopposed. As a result, the saffron flag of BJP has been hoisted in Sojitra APMC<br/>The winning candidates in the farmer category include Kishorbhai Chhotabhai Patel (Bhadkad), Jayeshbhai Narsinhbhai Patel (Dhaboi), Melabhai Kabhai bhai Gohil (Deva Talpad), Rajnikant Jashbhai Patel (Sojitra), Devtabhai Ravjibhai Patel (Kasor), and Maheshbhai Manibhai Patel (Isnana) among others.<br/>The BJP winning candidates expressed their gratitude to all the voters of the taluka.</p>",
    //       date: ' ',
    //       // img: `${require('../images/news6.jpg')}`,
    //       readmore: 'read More'
    //    },

    // ]
  },
  section3: {
    title: "વીડિયો",
    // news: [
    //    {
    //       title: 'ઇન્ટરવ્યુ',
    //       id: 'INTERVIEW',
    //       url: 'https://youtu.be/0GNAfi72zho?si=0V4ykFB_BzJrxFzR',
    //    },
    //    {
    //       title: 'ઇન્ટરવ્યુ',
    //       id: 'INTERVIEW',
    //       url: 'https://youtu.be/N7bHOfRhiSQ',
    //    },
    //    {
    //       title: 'ઇન્ટરવ્યુ',
    //       id: 'INTERVIEW',
    //       url: 'https://youtu.be/0czUsxNum_I',
    //    },
    //    {
    //       title: 'પાર્ટી ઇવેન્ટ્સ',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/M4YqP5fPVWg',
    //    },
    //    {
    //       title: 'પાર્ટી ઇવેન્ટ્સ',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/eZTUiPVG-rk',
    //    },
    //    {
    //       title: 'પાર્ટી ઇવેન્ટ્સ',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/eLig8YDS89Q',
    //    },
    //    {
    //       title: 'પાર્ટી ઇવેન્ટ્સ',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/M4YqP5fPVWg',
    //    },
    //    {
    //       title: 'પાર્ટી ઇવેન્ટ્સ',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/M4YqP5fPVWg',
    //    },
    //    {
    //       title: 'પાર્ટી ઇવેન્ટ્સ',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/e7gm4Mh_ST4',
    //    },
    //    {
    //       title: 'પાર્ટી ઇવેન્ટ્સ',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/1Z575rF7qSo',
    //    },
    //    {
    //       title: 'પાર્ટી ઇવેન્ટ્સ',
    //       id: 'PARTY EVENTS',
    //       url: 'https://youtu.be/7JNQ4Whn2iU',
    //    },
    //    {
    //       title: 'ચૂંટણી રેલી',
    //       id: 'ELECTION RALLY',
    //       url: 'https://youtu.be/BShMG9UuHhg',
    //    },
    //    {
    //       title: 'ચૂંટણી રેલી',
    //       id: 'ELECTION RALLY',
    //       url: 'https://youtu.be/i3XTfZnDyaU',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/iAmKjQNellY',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/S1YFq1W4jIE',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/xfsvE4ZRs6o',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/YjzJgK8VlF0',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/z8_4r8lLKoc',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/T9ODfvFeTYc',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/M4YqP5fPVWg',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/eZTUiPVG-rk',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/eLig8YDS89Q',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/M4YqP5fPVWg',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/ua3wHBnlLFE',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/e7gm4Mh_ST4',
    //    },
    //    {
    //       title: 'પ્રેસ કોન્ફરન્સ',
    //       id: 'PRESS CONFERENCE',
    //       url: 'https://youtu.be/1Z575rF7qSo',
    //    },
    //    {
    //       title: 'લાઇટર સાઇડ',
    //       id: 'LIGHTER SIDE',
    //       url: 'https://youtu.be/6CdM22yUXnI',
    //    },
    //    {
    //       title: 'લાઇટર સાઇડ',
    //       id: 'LIGHTER SIDE',
    //       url: 'https://youtu.be/6-HebmvUMd4',
    //    },
    //    {
    //       title: 'અન્ય',
    //       id: 'OTHER',
    //       url: 'https://youtu.be/NSeIl5mCCPg',
    //    },
    //    {
    //       title: 'અન્ય',
    //       id: 'OTHER',
    //       url: 'https://youtu.be/gAjxX7bifN4',
    //    },
    //    {
    //       title: 'અન્ય',
    //       id: 'OTHER',
    //       url: 'https://youtu.be/ByT2CJNrCzE',
    //    },

    // ]
  },
  section4: {
    title: "Editorials",
    // farmers1: {
    //    title: "Four nomination papers filed for Kadi Sarsi Bank elections",
    //    text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //    date: ' ',
    //    // img: `${require('../images/aditorials1.jpg')}`,
    //    readmore: 'Read More'
    // },
    // farmers2: [
    //    {
    //       title: "Four nomination papers filed for Kadi Sarsi Bank elections",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       img: `${require('../images/aditorials1.jpg')}`,
    //       readmore: 'Read More'
    //    },
    //    {
    //       title: "Tejas Patel elected unopposed as chairman of Petlad APMC",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
    //       date: ' ',
    //       // img: `${require('../images/aditorials2.jpg')}`,
    //       readmore: 'Read More'
    //    },
    //    {
    //       title: "Training for farmers on cashless transactions in Petlad",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",

    //       date: ' ',
    //       // img: `${require('../images/aditorials3.jpg')}`,
    //       readmore: 'Read More'
    //    },
    //    {
    //       title: "Online auction system will be set up for selling paddy",
    //       text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",

    //       date: ' ',
    //       img: `${require('../images/aditorials4.jpg')}`,
    //       readmore: 'Read More'
    //    },
    // ]
  },
  section5: {
    title: "Our Activity",
    activity: [
      {
        title: "Amul's 32 direct recruitments challenged",
        text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
        date: " ",
        // img: `${require('../images/pressOurActivity1.jpg')}`,
        readmore: "read More",
      },
      {
        title: "Farmers of Petlad-Sojitra will benefit",
        text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
        date: " ",
        // img: `${require('../images/pressOurActivity2.jpg')}`,
        readmore: "read More",
      },
      {
        title: " Groundbreaking ceremony of new building of Gujcomasol",
        text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
        date: " ",
        // img: `${require('../images/pressOurActivity3.jpg')}`,
        readmore: "read More",
      },
      {
        title:
          "Piplav Dairy Union member's membership canceled for supplying adulterated milk",
        text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
        date: " ",
        // img: `${require('../images/pressOurActivity4.jpg')}`,
        readmore: "read More",
      },
      {
        title:
          "Milk producers are in a bad condition due to not getting money for the last 8 days.",
        text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
        date: " ",
        // img: `${require('../images/pressOurActivity5.jpg')}`,
        readmore: "read More",
      },
      {
        title: "Historical decision to fight against black money welcomed",
        text: "<p> Last date to file nomination form is December 9th <br/><br/> Candidate and supporters submitting nomination form to the Deputy Collector</p>",
        date: " ",
        // img: `${require('../images/pressOurActivity6.jpg')}`,
        readmore: "read More",
      },
    ],
  },
};
const Press = () => {
  const { language } = useLanguage();
  const [pressData, setPressData] = useState();
  const [showNews, setShowNews] = useState();
  const [allNewstext, setAllNewsText] = useState(false);
  const [newsFilter, setNewsFilter] = useState();
  const [news, setNews] = useState();

  const [videosFilter, setVideosFilter] = useState();
  const [videos, setVideos] = useState();

  const [editorialsFilter, setEditorialsFilter] = useState();
  const [editorials, setEditorials] = useState();

  const [ourActivityFilter, setOurActivityFilter] = useState();
  const [ourActivity, setOurActivity] = useState();

  const [data, setData] = useState();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  });

  useEffect(() => {
    if (language) {
      setPressData(englishData);
    } else {
      setPressData(gujratData);
    }
  }, [language]);

  const date = new Date();
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}${month}${day}`;
  };

  const dateFomate = formatDate(date);
  const key = "KDCC";
  const token = md5(dateFomate + key);

  useEffect(() => {
    axios
      .post(
        `https://cms.tejashpatel.in/api/cmspage`,
        { lang: language ? "en" : "gu" },
        { headers: { "X-Custom-Token": token } }
      )
      .then((res) => {
        // console.log(res?.data);
        setData(res?.data?.data);
      })
      .catch((err) => {
        // console.log(err);
      });
  }, [language, token]);

  // console.log("data", data);

  useEffect(() => {
    setNewsFilter(data?.News?.[0]?.title);
  }, [data]);

  useEffect(() => {
    data?.News?.map((el) => {
      if (el?.title == newsFilter) {
        setNews(el?.detail);
      }
    });
  }, [data, newsFilter]);

  // videos

  useEffect(() => {
    setVideosFilter(data?.Videos?.[0]?.title);
  }, [data]);

  useEffect(() => {
    data?.Videos?.map((el) => {
      if (el?.title == videosFilter) {
        setVideos(el?.detail);
      }
    });
  }, [data, videosFilter]);

  // Editorials

  useEffect(() => {
    setEditorialsFilter(data?.Editorials?.[0]?.title);
  }, [data]);

  useEffect(() => {
    data?.Editorials?.map((el) => {
      if (el?.title == editorialsFilter) {
        setEditorials(el?.detail);
      }
    });
  }, [data, editorialsFilter]);

  // our Ativity

  useEffect(() => {
    setOurActivityFilter(data?.OurActivity?.[0]?.title);
  }, [data]);

  useEffect(() => {
    data?.OurActivity?.map((el) => {
      if (el?.title == ourActivityFilter) {
        setOurActivity(el?.detail);
      }
    });
  }, [data, ourActivityFilter]);

  useEffect(() => {
    const newsDivs = document.querySelectorAll(".newsTextBox");
    newsDivs.forEach((newsDiv) => {
      if (allNewstext) {
        newsDiv.classList.add("active");
      } else {
        newsDiv.classList.remove("active");
      }
    });
  }, [allNewstext]);

  useEffect(() => {
    setShowNews(news?.[0]);
  }, [news]);

  const newsf = () => {
    let arr = [];
    for (let i = 0; i < news?.length; i++) {
      arr.push(
        <Link
          activeClass="active"
          to="newsBox"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          onClick={() => setShowNews(news?.[i])}
        >
          <div class="position-relative h-100">
            <div>
              <img
                src={news?.[i]?.image}
                style={{ width: "100%", height: "100%", aspectRatio: "2/2.5" }}
                class="rounded-4 object-fit-contain   object-position-top"
                alt=""
              />
            </div>
            <div
              class="position-absolute bottom-0 w-100 text-start rounded-4"
              style={{
                background:
                  "linear-gradient(rgba(29,35,68,0) 0%, rgba(29,35,68) 50%, rgba(29,35,68) 100%)",
              }}
            >
              <div class="col-11 m-auto">
                <div style={{ height: "100px" }}></div>
                <p class="fs-5 fw-bold text-white">
                  <span style={{ color: "#EA5136" }}>{news?.[i]?.year} : </span>{" "}
                  {news?.[i]?.title}
                </p>
                <Link
                  activeClass="active"
                  to="newsBox"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  style={{
                    // textDecoration: "none",
                    color: "black",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowNews(news?.[i])}
                >
                  <p
                    class="fw-bold d-flex align-items-center gap-2 my-2"
                    style={{ color: "#EA5136", cursor: "pointer" }}
                  >
                    {" "}
                    <span>{language ? "Read More" : "વધુ વાંચો"}</span>{" "}
                    <span class="mt-1">
                      <i class="bi bi-arrow-right  "></i>
                    </span>{" "}
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </Link>
      );
    }
    return arr;
  };

  const activity = () => {
    let arr = [];
    for (let i = 0; i < ourActivity?.length; i++) {
      arr.push(
        <Link
          activeClass="active"
          to="newsBox"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          onClick={() => setShowNews(ourActivity?.[i])}
        >
          <div class="">
            <div>
              <img
                src={ourActivity?.[i]?.image}
                style={{ width: "100%", aspectRatio: "3/2" }}
                class="rounded-top-4 object-fit-cover object-position-top"
                alt=""
              />
            </div>
            <div class=" text-start  rounded-bottom-4 bg-white" style={{}}>
              <div class="col-11 m-auto ">
                <br />
                <p class="fs-5 fw-bold ">
                  <span style={{ color: "#EA5136" }}>
                    {ourActivity?.[i]?.year} :{" "}
                  </span>{" "}
                  {ourActivity?.[i]?.title}
                </p>
                <Link
                  activeClass="active"
                  to="newsBox"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  style={{
                    // textDecoration: "none",
                    color: "black",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowNews(ourActivity?.[i])}
                >
                  <p
                    class="fw-bold d-flex align-items-center gap-2 my-2"
                    style={{ color: "#EA5136", cursor: "pointer" }}
                  >
                    {" "}
                    <span>{language ? "Read More" : "વધુ વાંચો"}</span>{" "}
                    <span class="mt-1">
                      <i class="bi bi-arrow-right  "></i>
                    </span>{" "}
                  </p>
                </Link>
                <br />
              </div>
            </div>
          </div>
        </Link>
      );
    }
    return arr;
  };

  const youtubeVideos = () => {
    let arr = [];
    for (let i = 0; i < videos?.length; i++) {
      arr.push(
        <div class="">
          <ReactPlayer
            width="100%"
            height="680px"
            controls="false"
            url={videos?.[i]?.url}
          />
        </div>
      );
    }
    return arr;
  };

  return (
    <div class="overflow-x-hidden">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Tejash Patel | Official</title>
        <meta
          name="description"
          content="Tejash Patel, Chairman of KDCC Bank, Gujarat Tobacco Fedration, Petlad Sojitra Taluka Sangh, Solar Co-operative, Farmer’s FPO’s etc and Director of Gujcomasol,  Gujarat Regulated Markets Federation, APMC, Petlad etc. and RGB Delegate of Krubhco and IFFCO, New Delhi."
        />
        <meta
          name="keywords"
          content="Tejash Patel, Chairman of KDCC Bank, Gujarat Tobacco Fedration, Petlad Sojitra Taluka Sangh, Solar Co-operative, Farmer’s FPO’s etc and Director of Gujcomasol,  Gujarat Regulated Markets Federation, APMC, Petlad etc. and RGB Delegate of Krubhco and IFFCO, New Delhi."
        />
      </Helmet>
      <div class="orangeBg">
        <div>
          <p
            class="display-1 fw-bold experienceText text-white"
            data-aos="zoom-in"
            dangerouslySetInnerHTML={{ __html: pressData?.section1?.title }}
          ></p>
        </div>
      </div>

      <div class="sideBar">
        <div>
          <br />
          <div class="p-3 text-white fw-bold">
            {" "}
            <Link
              activeClass="active"
              to="naviNews"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              style={{
                // textDecoration: "none",
                color: "white",
                cursor: "pointer",
              }}
            >
              <p>{language ? <span>NEWS</span> : <span>સમાચાર</span>}</p>
            </Link>
          </div>

          <div class="p-3 text-white fw-bold">
            {" "}
            <Link
              activeClass="active"
              to="naviVideos"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              style={{
                // textDecoration: "none",
                color: "white",
                cursor: "pointer",
              }}
            >
              <p>{language ? <span>VIDEO</span> : <span>વીડિયો</span>}</p>
            </Link>
          </div>

          <div class="p-3 text-white fw-bold">
            {" "}
            <Link
              activeClass="active"
              to="naviEditorials"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              style={{
                // textDecoration: "none",
                color: "white",
                cursor: "pointer",
              }}
            >
              <p>
                {language ? <span>EDITORIALS</span> : <span>સંપાદકીય</span>}
              </p>
            </Link>
          </div>

          <div class="p-3 text-white fw-bold">
            {" "}
            <Link
              activeClass="active"
              to="naviActivity"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              style={{
                // textDecoration: "none",
                color: "white",
                cursor: "pointer",
              }}
            >
              <p>{language ? <span>ACTIVITY</span> : <span>પ્રવૃત્તિ</span>}</p>
            </Link>
          </div>

          <br />
          <div class="slideButton ">
            <i class="bi bi-arrow-left-short text-white fs-5"></i>
          </div>
        </div>
      </div>

      <div class="row gap-md-0 gap-4 flex-column-reverse flex-md-row m-0  newsBox ">
        <div class="col-md-7">
          <div class="col-10 m-auto text-start newsTextBox">
            <p class="fs-2 fw-semibold justifyT" data-aos="fade-right">
              {showNews?.title}
            </p>

            <p
              class="mt-3 justifyT"
              data-aos="fade-right"
              dangerouslySetInnerHTML={{ __html: showNews?.desc }}
            ></p>

            <p class="fw-bold mt-4" data-aos="fade-right">
              {showNews?.year}{" "}
            </p>
            <br />
            <br />
            {showNews?.text?.length < 0 ? (
              ""
            ) : (
              <div
                class="newsTextButton d-flex align-items-center justify-content-center"
                onClick={() => setAllNewsText(!allNewstext)}
              >
                {" "}
                {allNewstext ? (
                  <span class="fs-1 fw-bold">
                    <FaCaretUp />
                  </span>
                ) : (
                  <span class="fs-1 fw-bold">
                    <FaCaretDown />
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
        <div class="col-md-5" data-aos="fade-left">
          <img
            src={showNews?.image}
            style={{ width: "100%" }}
            class="rounded-4 object-fit-cover object-position-top"
            alt=""
          />
        </div>
      </div>
      <br />

      <div>
        <br />
        <div class="col-11 m-auto my-5">
          <p class="fs-1 fw-bold my-5 naviNews">
            {language ? "News" : "સમાચાર"}
          </p>

          <div
            class=" col-md-11 m-auto d-flex align-items-center gap-4"
            style={{ overflowX: "auto" }}
          >
            {data?.News?.map((el) => {
              return (
                <button
                  class="custom-btn btnBlue text-nowrap"
                  onClick={() => setNewsFilter(el.title)}
                >
                  <span>{el?.title}</span>
                </button>
              );
            })}
          </div>
          <div class="mt-5">
            <NewsSlider data={newsf()} />
          </div>
        </div>
      </div>

      <div class="col-11 m-auto">
        <p class="fs-1 fw-bold my-5 naviVideos">{pressData?.section3?.title}</p>
        <div
          class=" col-md-11 m-auto d-flex align-items-center gap-4"
          style={{ overflowX: "auto" }}
        >
          {data?.Videos.map((el) => {
            return (
              <button
                class="custom-btn btnBlue text-nowrap"
                onClick={() => setVideosFilter(el?.title)}
              >
                <span>{el?.title}</span>
              </button>
            );
          })}
        </div>
        <div class="my-5">
          <NewsSlider data={youtubeVideos()} />
        </div>

        {/* <div class=' row align-items-center justify-content-between gap-md-0 gap-5'>

               {
                  pressData?.section3?.news?.map((el) => {
                     return (
                        <div class='col-lg-6 col-md-6'>
                           <div class='col-11 m-auto'>
                              <ReactPlayer
                                 width="100%"
                                 height="50vh"
                                 controls="false"
                                 url={el.url}
                              />
                           </div>
                        </div>
                     )
                  })
               }

            </div> */}
      </div>

      <div>
        <br />

        <p class="fs-1 fw-bold my-5 naviEditorials">
          {language ? "Editorials" : "સંપાદકીય"}
        </p>

        <div
          class=" col-md-11 m-auto d-flex align-items-center gap-4"
          style={{ overflowX: "auto" }}
        >
          {data?.Editorials?.map((el) => {
            return (
              <button
                class="custom-btn btnBlue text-nowrap"
                onClick={() => setEditorialsFilter(el.title)}
              >
                <span>{el?.title}</span>
              </button>
            );
          })}
        </div>

        <div class="col-11 m-auto row mt-3">
          {editorials?.map((el, i) => {
            return (
              <div class="col-xl-3 col-lg-4 col-md-6 m-auto mt-4 ">
                <Link
                  activeClass="active"
                  to="newsBox"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  onClick={() => setShowNews(el)}
                >
                  <div class="  ">
                    <img
                      src={el.image}
                      style={{ aspectRatio: "2/1", width: "100%" }}
                      class="rounded-4 object-fit-cover object-position-top"
                      alt=""
                    />
                    <div class="text-start">
                      <p class="fs-5 fw-bold mt-2">
                        <span style={{ color: "#EA5136" }}>{el.year} : </span>{" "}
                        {el.title}
                      </p>
                      <Link
                        activeClass="active"
                        to="newsBox"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        style={{
                          // textDecoration: "none",
                          color: "black",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowNews(el)}
                      >
                        <p
                          class="fw-bold d-flex align-items-center gap-2 my-2"
                          style={{ color: "#EA5136", cursor: "pointer" }}
                        >
                          {" "}
                          <span>
                            {language ? "Read More" : "વધુ વાંચો"}
                          </span>{" "}
                          <span class="mt-1">
                            <i class="bi bi-arrow-right  "></i>
                          </span>{" "}
                        </p>
                      </Link>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
      <br />

      <div
        class="my-5"
        style={{ background: "linear-gradient(#727CB6 50%,#F5F2F2 50%)" }}
      >
        <div class="col-11 m-auto">
          <br />
          <p class="fs-1 fw-bold text-white text-start naviActivity ">
            {language ? "Our Activity" : "અમારી પ્રવૃત્તિ"}
          </p>
          <div
            class=" col-md-11 m-auto d-flex align-items-center gap-4"
            style={{ overflowX: "auto" }}
          >
            {data?.OurActivity?.map((el) => {
              return (
                <button
                  class="custom-btn btnBlue text-nowrap"
                  onClick={() => setEditorialsFilter(el.title)}
                >
                  <span>{el?.title}</span>
                </button>
              );
            })}
          </div>

          <div class="my-5">
            <HomeProject data={activity()} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Press;
